const arraysEqual = (a1, a2, compareObjectsFunc) =>
  a1.length === a2.length &&
  a1.every((o, idx) => compareObjectsFunc(o, a2[idx]));

export default arraysEqual;
